<template>
  <BaseRadioSelector
    :description="description"
    :items="isAdmin ? caldOptionsAdminFormatted : caldOptionsFormatted"
    label="CALD"
    :medium="medium"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

import BaseRadioSelector from "shared/components/selectors/radio/BaseRadioSelector.vue";
import type { MediumField } from "shared/helpers/media";

const CALD_OPTIONS = {
  excludeCald: "disabled",
  onlyCald: "exclusively",
  allSources: "enabled",
};

interface CaldRadioSelector {
  medium: MediumField;
  isAdmin?: boolean;
  disabled?: boolean;
}

const props = defineProps<CaldRadioSelector>();

const modelValue = defineModel<boolean | string>({ default: false });

const emit = defineEmits(["update:modelValue"]);

const description =
  "CALD is content from culturally and linguistically diverse sources";

const caldOptionsFormatted = computed(() => [
  {
    id: CALD_OPTIONS.allSources,
    name: "All sources",
    disabled: props.disabled,
  },
  {
    id: CALD_OPTIONS.excludeCald,
    name: "Exclude CALD content",
    disabled: props.disabled,
  },
  {
    id: CALD_OPTIONS.onlyCald,
    name: "Display CALD content only",
    disabled: props.disabled,
  },
]);

const caldOptionsAdminFormatted = computed(() => [
  {
    id: CALD_OPTIONS.allSources,
    name: "Include both CALD and Non-CALD",
    description: "Include both sources marked as CALD and all others.",
  },
  {
    id: CALD_OPTIONS.excludeCald,
    name: "Exclude CALD content",
    description:
      "This filter will include all non-CALD content, removing any source that is translated. Default option.",
  },
  {
    id: CALD_OPTIONS.onlyCald,
    name: "Only CALD",
    description:
      "This will filter will include only CALD content, removing any source that is not marked as cultural or translated.",
  },
]);
</script>
